export default __webpack_public_path__ + "static/NavRingInner-ffe75156c77bb381e468b7cb5557df19.png";